import { trackStoreClick } from "../analytics";

const APPLE_ICON = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#fff">
    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.7 9.05 7.4c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.39-1.32 2.76-2.54 3.99zM13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
  </svg>
);

const GOOGLE_ICON = (
  <svg width="22" height="22" viewBox="0 0 24 24">
    <path d="M3.4 2.1A1.5 1.5 0 002 3.7v16.6a1.5 1.5 0 001.4 1.6l9.6-9.9L3.4 2.1z" fill="#EA4335"/>
    <path d="M16.3 9l-3.1 3 3.1 3 3.5-2c.9-.5.9-1.9 0-2.4L16.3 9z" fill="#FBBC05"/>
    <path d="M13.2 12L3.4 21.9c.3.2.7.1 1.1-.1L16.3 15l-3.1-3z" fill="#34A853"/>
    <path d="M3.4 2.1c-.4-.2-.8-.3-1.1-.1L13.2 12l3.1-3L4.5 2.2c-.4-.2-.8-.3-1.1-.1z" fill="#4285F4"/>
  </svg>
);

const URLS = {
  apple:  "https://apps.apple.com/pl/app/wychodzi/id6772133520",
  google: "https://play.google.com/store/apps/details?id=app.wychodzi",
};

/**
 * Store button — mirrors mobile's gradient-border auth pill.
 * - kind: "apple" | "google"
 * - dark: lifted variant for use inside dark accent blocks
 */
export default function StoreBtn({ kind, dark = false, location = "unknown" }) {
  const isApple = kind === "apple";

  return (
    <a
      href={URLS[kind]}
      target="_blank"
      rel="noreferrer"
      className="store-btn"
      onClick={() => trackStoreClick(kind, location)}
    >
      <span className={`store-btn-inner ${dark ? "store-btn-inner-dark" : "store-btn-inner-solid"}`}>
        <span className="store-btn-icon">{isApple ? APPLE_ICON : GOOGLE_ICON}</span>
        <span style={{ display: "flex", flexDirection: "column" }}>
          <span className="store-btn-sub">{isApple ? "ЗАГРУЗИТЕ В" : "ДОСТУПНО В"}</span>
          <span className="store-btn-name">{isApple ? "App Store" : "Google Play"}</span>
        </span>
      </span>
    </a>
  );
}
